/**
 * 관리자용 회원찾기 모달 ($j.Ui.JBModal.target 과 결합)
 *
 * 사용법:
 *   $j.Ui.JBModal.target('find-member', {
 *       target: '$j.F.Admin.Member.Find',
 *       data: { field: 'mem_introducer', is_owner: false, onSelect: (num, text) => {...} },
 *       title: '기사검색',
 *       width: '460px',
 *   });
 *
 * data.field    이 있으면 선택 시 #{field}, input[name={field}] 에 text/num 을 자동 주입.
 * data.onSelect 콜백이 있으면 (num, text) 로 호출.
 *
 * 레거시 public/find_user.php (iframe 모달) 대체.
 */
import Util from '../../../Common/Util';

export default class Find {
    constructor() {
        this.$wrap = null;
    }
    destroy() {
    }
    init() {
        this.field = this.data.field || '';
        this.isOwner = this.data.is_owner ? 1 : 0;
        this.draw();
        this.bind();
        this.search();
    }
    draw() {
        let html = `
        <style>
            .fu-wrap {font-size:13px}
            .fu-wrap .fu-search {display:flex;align-items:center;gap:8px;margin-bottom:10px}
            .fu-wrap .fu-search label {font-weight:bold;white-space:nowrap}
            .fu-wrap .fu-search input {flex:1;height:32px;padding:4px 8px;border:1px solid #ccc;border-radius:3px;font-size:13px}
            .fu-wrap .fu-result {max-height:200px;overflow-y:auto}
            .fu-wrap .fu-result table {width:100%;border-collapse:collapse}
            .fu-wrap .fu-result table td {padding:6px 8px;border-bottom:1px solid #eee}
            .fu-wrap .fu-result table tr:hover {background:#f5f5f5}
            .fu-wrap .fu-result .fu-empty {color:#999;text-align:center;padding:20px 0}
            .fu-wrap .btn1 {padding:3px 10px;background:#5b9bd5;color:#fff;border:1px solid #4a8ac4;border-radius:3px;cursor:pointer;font-size:12px}
            .fu-wrap .btn1:hover {background:#4a8ac4}
        </style>
        <div class="fu-wrap">
            <div class="fu-search">
                <label>검색어</label>
                <input type="text" id="fu-keyword" placeholder="기사명, 전화, 코드" />
            </div>
            <div class="fu-result">
                <div class="fu-empty" id="fu-result">검색결과 없음</div>
            </div>
        </div>`;
        $(`#${this.id}`).html(html);
        this.$wrap = $(`#${this.id}`);
    }
    bind() {
        const self = this;
        this.$wrap.find('#fu-keyword').on('keyup', function () {
            self.search();
        });
    }
    search() {
        let kwd = this.$wrap.find('#fu-keyword').val() || '';
        if (kwd.length < 2) return;

        const self = this;
        $.ajax({
            type: 'get',
            dataType: 'json',
            url: '/adm/ajax/member/find',
            data: {kwd: kwd, own: self.isOwner},
            success: function (arr) {
                if (!arr.length) {
                    self.$wrap.find('#fu-result').html('<div class="fu-empty">검색결과 없음</div>');
                    return;
                }
                let html = '<table>';
                $.each(arr, function (i, item) {
                    let showtext = `${item.mem_name} (${item.num})`;
                    let color = item.mem_status == 0 ? '#333' : '#aaa';
                    html += `<tr style="color:${color}">
                        <td><button class="btn1 fu-select" type="button" data-num="${item.num}" data-text="${Util.escapeHtml(showtext)}">선택</button></td>
                        <td>${Util.int(item.num)}</td>
                        <td><b>${Util.escapeHtml(item.mem_name)}</b></td>
                        <td>${Util.escapeHtml(item.mem_phone)}</td>
                    </tr>`;
                });
                html += '</table>';
                self.$wrap.find('#fu-result').html(html);

                self.$wrap.find('.fu-select').off('click').on('click', function () {
                    let num = $(this).data('num');
                    let text = $(this).data('text');
                    self.select(num, text);
                });
            }
        });
    }
    select(num, text) {
        let field = this.field;
        if (field) {
            $(`#${field}`).val(text);
            $(`input[name=${field}]`).val(num);
        }
        if (typeof this.data.onSelect === 'function') {
            this.data.onSelect(num, text);
        }
        $j.Ui.JBModal.close();
    }
}
